import React, { ReactNode } from 'react';
import { NotFoundSVG, ReloadIcon } from '../components/common/Icons';

const VitalFileDisplay: React.FC<{ text: string; icon?: ReactNode; onRetry?: () => void }> = ({
    text,
    onRetry,
    icon,
}) => {
    return (
        <div className="flex flex-col gap-16 items-center w-full justify-center">
            {icon ?? <NotFoundSVG />}
            <div className="flex flex-col gap-8 items-center">
                <p className="font-400 text-21">{text}</p>
                {onRetry && (
                    <span
                        className="flex items-center gap-4 capitalize text-actionPrimary font-700 cursor-pointer"
                        onClick={onRetry}
                    >
                        <ReloadIcon /> Retry
                    </span>
                )}
            </div>
        </div>
    );
};

export default VitalFileDisplay;
